import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { useStyles } from '../styles/index.js';
import { computeResponsiveness } from '../../../../foundation/responsive/helpers/index.js';
import { CornerRadius } from '../../../../foundation/cornerRadius/cornerRadius/index.js';

const Skeleton = forwardRef(({ className, width, height, borderRadius = CornerRadius.r0, }, ref) => {
    const widths = computeResponsiveness(width);
    const heights = computeResponsiveness(height);
    const radii = computeResponsiveness(borderRadius);
    const styles = useStyles({
        widths,
        heights,
        radii,
    });
    return (jsx("div", { ref: ref, className: clsx(styles.root, className), "data-testid": "skeleton" }));
});
Skeleton.displayName = 'Skeleton';

export { Skeleton };
